import React, { useState } from "react";
import { Formik, Field } from "formik";
import {
  FormGroup,
  Page,
  SubmitButton,
  Editor,
  FileUpload,
  Checkbox,
} from "components/common";
import { useFormHelpers, useAsyncEffect } from "hooks";
import { NotificationManager } from "react-notifications";
import {isFloat} from "validator";

export const Form = ({ title, values }) => {
  return (
    <Page title={title}>
      <FormGroup name="name" label="Name">
        <Field name="name" className="form-control" />
      </FormGroup>
      <FormGroup name="content" label="Content">
        <Field name="content" component={Editor} />
      </FormGroup>
      <FormGroup name="display" label="Display on the Welcome page?" check>
        <Field
          name="display"
          component={Checkbox}
          className="form-check-input"
        />
      </FormGroup>
      <FormGroup name="ordering" label="Ordering">
        <Field name="ordering" className="form-control" validate={(v) => {
          if (!v) return false;
          if (isFloat(v + "")) return false;
          return "invalid";
        }} />
      </FormGroup>
      <FormGroup name="file" label="File">
        <Field
          name="file"
          validate={(v) => !(v || values.file__name)}
          component={FileUpload}
        />
      </FormGroup>
      <div className="tw-flex tw-justify-end">
        <SubmitButton>Save</SubmitButton>
      </div>
    </Page>
  );
};

export const Edit = ({ directoryId, reload }) => {
  const {
    validationObject,
    setInitialValues,
    initialValues,
    load,
    save,
    replacePathId,
    pageTitle,
  } = useFormHelpers({
    url: `resource_directories/${directoryId}/files`,
    resource: "Resource",
  });

  useAsyncEffect(async () => {
    const initialValues = await load({
      name: "",
      content: {
        blocks: [],
        entityMap: {},
      },
      file: null,
      display: false,
    });
    setInitialValues(initialValues);
  }, []);

  async function onSubmit(x, { setSubmitting }) {
    try {
      const resp = await save({
        ...x,
        ordering: x.ordering ? x.ordering : null,
      });
      replacePathId(resp.id, { reload: false });
      reload();
      NotificationManager.success("Saved successfully");
    } finally {
      setSubmitting(false);
    }
  }

  if (!initialValues) return null;

  return (
    <>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validationObject({
          name: (v) => !v,
          content: (v) => !v,
        })}
      >
        {(formik) => <Form title={pageTitle} {...formik} />}
      </Formik>
    </>
  );
};

export default (props) => {
  const [key, setKey] = useState();
  return <Edit {...props} reload={() => setKey((v) => !v)} key={key} />;
};
